type DeleteFromLocalStorageType = (keys: string | string[]) => void;
export const deleteFromLocalStorage: DeleteFromLocalStorageType = (keys) => {
  Array.isArray(keys)
    ? keys.forEach(key => localStorage.removeItem(key))
    : localStorage.removeItem(keys);
};
